import { Injectable } from '@angular/core'

import { Router } from '@angular/router'
import { ActionAfterAuthenticationLemonator, NetsEnvironment } from '@lemon/core-firebase/model/tunnistaminen'
import { LocalStorageService } from 'app/_jaettu-angular/service/local-storage.service'
import { EnvironmentType } from '../../app.environment'

type NetsAuthenticationResult = 'success' | 'error' | 'error-cancel'

interface TunnistautuminenClientSession {
  action: ActionAfterAuthenticationLemonator
  state: string
  sessionAvain: string
  startedAtMillis: number
  linkinAvain?: string // Taikalinkin avain tilintarkastajan kutsulle
}

@Injectable()
export class TunnistautuminenService {
  private _currentSessionKey = 'tunnistauminen-session'
  private _tunnistautuminenState: NetsAuthenticationResult = null
  private _tunnistautuminenAction: ActionAfterAuthenticationLemonator = null

  constructor(
    private _localStorageService: LocalStorageService,
    private _router: Router,
  ) {}

  navigateByAction(action: ActionAfterAuthenticationLemonator, data?: unknown) {
    this._tunnistautuminenAction = action
    if (action === 'continue-tilintarkastaja-tunnistautuminen') {
      this._router.navigate(['tilintarkastajat/tunnistaudu'], { state: data })
    } else if (action === 'continue-tilintarkastaja-kirjautuminen') {
      this._router.navigate(['tilintarkastajat/kirjaudu'], { state: data })
    } else {
      throw new Error('unknown action ' + action)
    }
  }

  setTunnistautuminenState(state: NetsAuthenticationResult) {
    this._tunnistautuminenState = state
  }

  getTunnistautuminenState(): NetsAuthenticationResult {
    return this._tunnistautuminenState
  }

  getTunnistautuminenAction(): ActionAfterAuthenticationLemonator {
    return this._tunnistautuminenAction
  }

  /**
   * Kirjoittaa tunnistautumissession tiedot SessionStorageen. Huomaa asynkroninen ja uudelleenyrittävä toteutustapa.
   * Tarkoituksena varmistua, että tieto on todellisuudessa tallentunut ennen kun suoritusta jatketaan eteenpäin, koska
   * data on kriittistä tunnistautumisen kannalta.
   */
  public async startClientSideAuthenticationSession(action: ActionAfterAuthenticationLemonator, sessionAvain: string, state: string) {
    return this._localStorageService.setToSessionStorageUntilVerified<TunnistautuminenClientSession>(this._currentSessionKey, {
      action: action,
      state: state,
      sessionAvain: sessionAvain,
      startedAtMillis: new Date().getTime(),
    })
  }

  public getClientSideAuthenticationSession(): TunnistautuminenClientSession {
    return this._localStorageService.getFromSessionStorage<TunnistautuminenClientSession>(this._currentSessionKey)
  }

  public endClientSideAuthenticationSession() {
    this._localStorageService.deleteFromSessionStorage(this._currentSessionKey)
    this._tunnistautuminenState = null
    this._tunnistautuminenAction = null
  }

  getNetsEnvironment(environment: EnvironmentType): NetsEnvironment {
    if (environment === EnvironmentType.PRODUCTION) {
      return 'prod'
    } else if (environment === EnvironmentType.BETA) {
      return 'beta'
    } else if (environment === EnvironmentType.DEV) {
      return 'dev'
    } else if (environment === EnvironmentType.LOCAL_DEV) {
      return 'local-dev'
    }
    throw new Error('Unknown environment ' + environment)
  }
}
